// broker-report-sync routes (ADR-0002): SCR-02 /sync, SCR-03 /sync/:accountId, SCR-04 /reports, SCR-05 /accounts/:accountId.
export const SYNC_UNITS_PATH = "/sync";
export const SYNC_UNIT_ROUTE = "/sync/:accountId";
export const MY_ACCOUNTS_PATH = "/reports";
export const INVESTING_ACCOUNT_ROUTE = "/accounts/:accountId";

export const syncUnitPath = (accountId) => `${SYNC_UNITS_PATH}/${encodeURIComponent(accountId)}`;
export const investingAccountPath = (accountId) => `/accounts/${encodeURIComponent(accountId)}`;
